export default __webpack_public_path__ + "static/media/bg_metalheads.c06482c1.svg";